import { Box, Typography } from '@mui/material';
import { colors, cardSx } from '../theme/designTheme';

/**
 * Renders a vertical timeline of alert events.
 * Props: events = [{ date: "YYYY-MM-DD", event: string }]
 */
const AlertTimeline = ({ events, settlementDate }) => {
  const list = Array.isArray(events) ? events : [];
  const today = new Date().toISOString().slice(0, 10);

  return (
    <Box sx={{ ...cardSx, p: 2.5 }}>
      <Typography sx={{ color: colors.textPrimary, fontFamily: 'Lexend', fontWeight: 700, fontSize: '13px', mb: 2 }}>
        Alert Timeline
      </Typography>

      {list.length === 0 ? (
        <Typography sx={{ color: colors.textMuted, fontFamily: 'Lexend', fontSize: '11px' }}>
          No timeline events recorded.
        </Typography>
      ) : (
        <Box sx={{ position: 'relative', pl: 2 }}>
          {/* Vertical line */}
          <Box sx={{
            position: 'absolute', left: 5, top: 6, bottom: 6,
            width: '1px', bgcolor: colors.borderSubtle,
          }} />

          {list.map((e, i) => {
            const isFuture = e.date && e.date > today;
            const isSettlement = settlementDate && e.date === settlementDate;
            const dotColor = isSettlement ? colors.critical : isFuture ? colors.medium : colors.accent;
            return (
              <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', mb: i === list.length - 1 ? 0 : 1.75, position: 'relative' }}>
                <Box sx={{
                  position: 'absolute', left: -15, top: 4,
                  width: 11, height: 11, borderRadius: '50%',
                  bgcolor: dotColor,
                  border: `2px solid ${colors.surface}`,
                  boxShadow: isSettlement ? `0 0 8px ${dotColor}` : 'none',
                }} />
                <Box>
                  <Typography sx={{ color: dotColor, fontFamily: 'Lexend', fontSize: '10px', fontWeight: 700, letterSpacing: '0.05em' }}>
                    {e.date}{isSettlement ? ' · DEADLINE' : isFuture ? ' · SCHEDULED' : ''}
                  </Typography>
                  <Typography sx={{ color: colors.textSecondary, fontFamily: 'Lexend', fontSize: '12px', mt: 0.25, lineHeight: 1.4 }}>
                    {e.event}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default AlertTimeline;
